export default [{
  path: '/statistic/displayBoard',
  name: 'displayBoard',
  meta: {
    pageId: 10007,
    keepAlive: true,
    spm: 2296,
  },
  component: () => import('@/pages/statistic/displayBoard/dataBoard/index.vue'),
},
{
  path: '/statistic/displayBoard/infoDetail',
  name: 'infoDetail',
  meta: {
    pageId: 10008,
    spm: 2297,
  },
  component: () => import('@/pages/statistic/displayBoard/detailBoard/index.vue'),
},
{
  path: '/statistic/summary',
  name: 'statisticSummary',
  meta: {
    pageId: 10003,
    spm: 2298,
  },
  component: () => import('@/pages/statistic/summary/index.vue'),
},
{
  path: '/statistic/order',
  name: 'statisticOrder',
  meta: {
    pageId: 10004,
    spm: 2299,
  },
  component: () => import(/* webpackChunkName: "statisticOrder" */'@/pages/statistic/order/index.vue'),
},
];
